// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2EGVg","fileBtn":"File_fileBtn__3SuTl","closeBtn":"File_closeBtn__1E5Ef","fileSelected":"File_fileSelected__1iqb4","disabled":"File_disabled__oIFZN"};